export default __webpack_public_path__ + "static/portfolio_gallery_29-35c3b1aaa78b67b393efb7bbdf20bfab.jpg";